import TransactionHistoryList from "../../../components/TransactionHistoryList";

const History = () => {
  return (
    <div className="relative w-full flex gap-5 px-5 md:px-10 py-5 flex-col">
      <div></div>
      <TransactionHistoryList />
    </div>
  );
};

export default History;
